import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliverableCustomerOrdersDataGrid } from "src/components/views/erp/sales/delivery/DeliverableCustomerOrdersDataGrid.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/delivery/deliverableCustomerOrders")({
	staticData: { title: i18n.t("deliverable_orders"), legacyViewKey: "deliverableCustomerOrdersView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <DeliverableCustomerOrdersDataGrid isActive={isActive} />;
}
